import React, { Fragment } from "react"

import type { Stakeholder } from "../../../../types/types"
import BackgroundImage from "../../../common/BackgroundImage"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ShortTextWithReadMore from "../../../common/ShortTextWithReadMore"

const StakeholderViewItemDetails = ({
    full_name,
    primary_organisation,
    primary_position,
    bio,
    photo_url,
    type,
    isFetching
}: Stakeholder) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />Full Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={20}
                maxLineLength={50}
            >
                <p data-cy="stakeholderFullName">{full_name || "No name"}</p>
            </ContentLoaderLines>
            {type === "Person" && (
                <Fragment>
                    <h3>
                        <i className="icon icon-user-primary-org" />Primary
                        Organisation
                    </h3>
                    <ContentLoaderLines
                        isFetching={isFetching}
                        minLineLength={20}
                        maxLineLength={50}
                    >
                        <p data-cy="primaryOrganisationViewMode">
                            {primary_organisation || "No organisation"}
                        </p>
                    </ContentLoaderLines>
                    <h3>
                        <i className="icon icon-user-primary-position" />Primary
                        Position
                    </h3>
                    <ContentLoaderLines
                        isFetching={isFetching}
                        minLineLength={20}
                        maxLineLength={50}
                    >
                        <p data-cy="primaryPositionViewMode">
                            {primary_position || "No position"}
                        </p>
                    </ContentLoaderLines>
                </Fragment>
            )}
            <h3>
                <i className="icon icon-description" />Bio
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={2}
                maxLines={5}
            >
                <ShortTextWithReadMore
                    text={bio}
                    placeholder="No bio"
                    dataCy="bioFieldViewMode"
                />
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-heroimg" />User Picture
            </h3>
            <BackgroundImage
                classList={[
                    "item-background-image thumb-rounded full-background-opacity"
                ]}
                imageUrl={photo_url}
                isThumbnail={true}
            />
        </div>
    </div>
)

export default StakeholderViewItemDetails
